import * as fromDatatype from "../datatype-library/index";

export interface bl_wms_picking_list_gendoc_link_RowInterface {
    guid :fromDatatype.GuidDataFieldInterface;
    picking_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
    gendoc_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    qty_to_pick: fromDatatype.NumericDatatypeInterface;
    remarks :fromDatatype.VarcharDatatypeInterface;
    namespace :fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}

export class bl_wms_picking_list_gendoc_link_RowClass implements bl_wms_picking_list_gendoc_link_RowInterface {
    guid :fromDatatype.GuidDataFieldInterface;
    picking_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
    gendoc_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    qty_to_pick: fromDatatype.NumericDatatypeInterface;
    remarks :fromDatatype.VarcharDatatypeInterface;
    namespace :fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}